import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const PracticeInformationStep = ({ formData, onChange }) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-6">
        <Icon name="Building2" size={24} className="text-blue-600" />
        <div>
          <h2 className="text-xl font-bold text-gray-900">Informations du Cabinet</h2>
          <p className="text-sm text-gray-600">Détails de la pratique endodontique</p>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Nom du Cabinet <span className="text-red-500">*</span>
        </label>
        <Input
          value={formData?.practiceName}
          onChange={(e) => onChange?.('practiceName', e?.target?.value)}
          placeholder="Cabinet Dr Dupont - Endodontie Exclusive"
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Titre <span className="text-red-500">*</span>
          </label>
          <select
            value={formData?.practitionerTitle}
            onChange={(e) => onChange?.('practitionerTitle', e?.target?.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="Dr">Dr</option>
            <option value="Pr">Pr</option>
          </select>
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nom du Praticien <span className="text-red-500">*</span>
          </label>
          <Input
            value={formData?.practitionerName}
            onChange={(e) => onChange?.('practitionerName', e?.target?.value)}
            placeholder="Dupont"
            required
          />
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Spécialité
        </label>
        <Input
          value={formData?.specialty}
          onChange={(e) => onChange?.('specialty', e?.target?.value)}
          placeholder="Endodontie"
        />
      </div>
    </div>
  );
};

export default PracticeInformationStep;